import React, { useState } from "react";
import {
  Heart,
  Info,
  MoreHorizontal,
  MoveUpLeft,
  PlusCircle,
  RadioTower,
  Share,
} from "lucide-react";

import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSeparator,
  MenubarTrigger,
} from "@ui/menubar";
import { Button } from "@ui/button";
import TranslatedText from "@components/items/display/TranslatedText";
import CurrentPlaylists from "../my-corner/CurrentPlaylists";
import { SVG } from "@components/items/common/SVG";
import useCurrentPlan from "@utils/hooks/useCurrentPlan";
import { useAppNavigate } from "@utils/hooks/useAppNavigate";

interface BookMenuProps {
  onShareClick: () => void;
}

const BookMenu = ({ onShareClick }: BookMenuProps) => {
  const navigate = useAppNavigate();
  const { plan } = useCurrentPlan();
  const [isCurrentPlaylistOpen, setIsCurrentPlaylistOpen] =
    useState<boolean>(false);

  return (
    <>
      <CurrentPlaylists
        isOpen={isCurrentPlaylistOpen}
        setOpen={setIsCurrentPlaylistOpen}
      />
      <Menubar className="border-none bg-transparent" dir="rtl">
        <MenubarMenu>
          <MenubarTrigger
            asChild
            className="cursor-pointer rounded-none focus:bg-transparent focus-visible:ring-0 data-[state=open]:bg-transparent"
          >
            <Button variant="basic" className="bg-transparent">
              <MoreHorizontal size={25} />
            </Button>
          </MenubarTrigger>
          <MenubarContent
            align="end"
            className="bg-[#F9F9F9] text-[#898A8D] dark:bg-[#4F5056] dark:text-white"
          >
            {/* <MenubarItem
            inset={true}
            className="flex justify-between items-center px-3 py-2"
          >
            <div>
              <TranslatedText
                text={`${"content-details"}.${"book-menu"}.${"favorite"}`}
              />
            </div>
            <div>
              <Heart />
            </div>
          </MenubarItem>
          <MenubarSeparator /> */}
            <MenubarItem
              inset={false}
              className="flex cursor-pointer items-center justify-between px-3 py-2"
              onClick={() => {
                if (!plan?.isFree) {
                  setIsCurrentPlaylistOpen(true);
                }
              }}
            >
              {plan?.isFree ? (
                <a
                  href={
                    "https://pay.wajeez.com/?content=registerMethod&subscriptionType=P1Y"
                  }
                  rel="noopener noreferrer"
                  className="flex w-full items-center justify-between gap-x-4 py-2"
                >
                  <div>
                    <TranslatedText
                      text={`${"content-details"}.${"book-menu"}.${"add-to-playlist"}`}
                    />
                  </div>
                  <div>
                    <SVG src="/assets/icons/crown.svg" />
                  </div>
                </a>
              ) : (
                <div className="flex w-full items-center justify-between gap-x-4 py-2">
                  <div>
                    <TranslatedText
                      text={`${"content-details"}.${"book-menu"}.${"add-to-playlist"}`}
                    />
                  </div>
                  <div>
                    <PlusCircle />
                  </div>
                </div>
              )}
            </MenubarItem>
            <MenubarSeparator />
            <MenubarItem
              inset={false}
              className="flex cursor-pointer items-center justify-between px-3 py-2"
              onClick={onShareClick}
            >
              <div>
                <TranslatedText
                  text={`${"content-details"}.${"book-menu"}.${"sharing"}`}
                />
              </div>
              <div>
                <Share />
              </div>
            </MenubarItem>
            <MenubarSeparator />
            {/* <MenubarItem
            inset={true}
            className="flex justify-between items-center px-3 py-2"
          >
            <div>
              <TranslatedText
                text={`${"content-details"}.${"book-menu"}.${"listening-settings"}`}
              />
            </div>
            <div>
              <MoveUpLeft />
            </div>
          </MenubarItem>
          <MenubarSeparator /> */}
            {/* <MenubarItem
            inset={true}
            className="flex justify-between items-center px-3 py-2"
          >
            <div>
              <TranslatedText
                text={`${"content-details"}.${"book-menu"}.${"address-details"}`}
              />
            </div>
            <div>
              <Info />
            </div>
          </MenubarItem> */}
            {/* <MenubarItem
            inset={true}
            className="flex justify-between items-center px-3 py-2"
          >
            <div>
              <TranslatedText
                text={`${"content-details"}.${"book-menu"}.${"fast-streaming"}`}
              />
            </div>
            <div>
              <RadioTower />
            </div>
          </MenubarItem> */}
          </MenubarContent>
        </MenubarMenu>
      </Menubar>
    </>
  );
};

export default BookMenu;
